module.exports = __webpack_public_path__ + "img/big_1_33.c7871b23.png";